import { I18n } from '@cainiaofe/cn-i18n';
import locale from './index';
export default new I18n({ locale, packageName: 'cn-ui' });
